import type { NavigationTypeType, SDK_Fonts } from "@quickpoint.me/shared";

import { mainCssRules } from "./lib/cssTemplates";
import styled from "styled-components";
import vieweratiCss from "./css/viewerati";

const showScroller = ({
	isInLandscape,
	forceSingleColumn,
	navigationType,
}: { isInLandscape: boolean; forceSingleColumn: boolean; navigationType: NavigationTypeType }) => {
	if (navigationType === "scroll") return true;
	if (navigationType === "scrollCards") return false;
	if (navigationType === "scrollContinuous") return false;
	// WCAG 1.4.10: Allow scrolling when font is enlarged (forceSingleColumn)
	if (isInLandscape && !forceSingleColumn) return false;
	return true;
};

const StyledDisplay = styled.div<{
	$constrainDimensions: boolean;
	$isPreviewer: boolean;
	$baseFontSize: number;
	$baseFontSizeRaw: number;
	$isInLandscape: boolean;
	$forceSingleColumn: boolean;
	$navigationType: NavigationTypeType;
	$fonts: SDK_Fonts;
	$height: number;
	$width: number;
}>`
${vieweratiCss};
position: ${(props) => (props.$constrainDimensions ? "relative" : "fixed")};
width: 100%;
overflow-x: hidden;
overflow-y: ${(props) =>
	showScroller({
		navigationType: props.$navigationType,
		isInLandscape: props.$isInLandscape,
		forceSingleColumn: props.$forceSingleColumn,
	})
		? "auto"
		: "hidden"};
height: ${(props) => (props.$constrainDimensions ? "100%" : props.$navigationType === "tap" ? "100svh" : "100svh")};
/* page turns move focus to the slide's first heading so screen readers
   read from the top — those targets are tabindex="-1" (not in the tab
   order), so per the skip-link convention they show no focus ring.
   Interactive elements keep their rings (WCAG 2.4.7 covers those). */
[tabindex="-1"]:focus {
	outline: none;
}
.inline-link {
cursor: pointer;
${(props) =>
	`${mainCssRules({
		baseFontSize: props.$baseFontSize,
		baseFontSizeRaw: props.$baseFontSizeRaw,
		fonts: props.$fonts,
		theme: props.theme.link,
	})}`}
font-size: inherit;
font-family: inherit;

}
`;

export default StyledDisplay;
